import React from 'react';
import { green } from 'globals/colors';

interface FsPlusInCircleIconProps {
  color?: string;
  className?: string;
}

const FsPlusInCircleIcon: React.FC<FsPlusInCircleIconProps> = ({
  color = green.MAIN,
  className,
}) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z"
        fill={color}
      />
      <path
        d="M9.0303 12V8.98009H12V8.01991H9.0303V5H7.9697V8.01991H5V8.98009H7.9697V12H9.0303Z"
        fill="white"
      />
    </svg>
  );
};

export default FsPlusInCircleIcon;
